import { get, post, put } from '../libs/query'
import { API_TEMPLATE } from '../libs/constant'
import { formatUrl } from '../libs/url'

export const classroomApi = {
  classroomList ({ criteria, page, size }, queryString) {
    const path = API_TEMPLATE.CLASSROOM_LIST
    return post(path, { criteria, page, size, sortOrders: queryString?.sortOrders })
  },
  createClassroom (payload) {
    return post(`${API_TEMPLATE.CLASSROOM_CREATE}`, payload)
  },
  updateClassroom (id, payload) {
    const path = formatUrl(API_TEMPLATE.CLASSROOM_UPDATE, [{ key: 'id', value: id }])
    return put(path, payload)
  },
  changeStatus (id, payload) {
    const path = formatUrl(API_TEMPLATE.CLASSROOM_CHANGE_STATUS, [{ key: 'id', value: id }])
    return put(path, payload)
  },
  getDetail (id) {
    const path = formatUrl(API_TEMPLATE.CLASSROOM_DETAIL, [{ key: 'id', value: id }])
    return get(path)
  },
  getListClassroomNotRole () {
    return get(`${API_TEMPLATE.GET_CLASSROOM}`)
  }
}
